import React from "react";
import ImpersonateForm from "../forms/ImpersonateForm/ImpersonateForm";

const Impersonate: React.FC = () => {
  return (
    <>
      <ImpersonateForm />
    </>
  );
};

export default Impersonate;
